import { Fragment } from "react";
import { siteCopy } from "../../content";
import styles from "./LegalPanels.module.css";

export function AboutPanel() {
  const copy = siteCopy.about;

  return (
    <div className={styles.copy}>
      {copy.paragraphs.map((paragraph) => (
        <p key={paragraph}>{paragraph}</p>
      ))}
      <a
        className={styles.link}
        href={copy.linkHref}
        rel="noreferrer"
        target="_blank"
      >
        {copy.linkLabel}
        <span aria-hidden="true"> ↗</span>
      </a>
    </div>
  );
}

export function PrivacyPanel() {
  const copy = siteCopy.privacy;

  return (
    <div className={styles.copy}>
      {copy.statusNote ? (
        <p className={styles.status}>{copy.statusNote}</p>
      ) : null}

      {/* Fragments, not wrappers: the panel's CSS targets the headings and
          paragraphs as direct children of `.copy`. */}
      {copy.sections.map((section) => (
        <Fragment key={section.heading}>
          <h3>{section.heading}</h3>
          <p>{section.body}</p>
        </Fragment>
      ))}
    </div>
  );
}
